import { CIRCLE_NUMBER_TYPE } from "@visactor/vrender-core";

import { PickerBase } from "../common/base";

export class DefaultCanvasCirclePicker extends PickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "circle", this.numberType = CIRCLE_NUMBER_TYPE;
    }
}
//# sourceMappingURL=circle-picker.js.map
